import { useUser } from "@clerk/clerk-react";
import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { SubscriptionManager } from "@/components/subscription/SubscriptionManager";
import { Button } from "@/components/ui/button";
import { Settings, CreditCard, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Account() {
  const { user } = useUser();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-8">Account Overview</h1>
        
        <div className="grid gap-6">
          {/* Profile Summary */}
          <Card className="p-6">
            <div className="flex items-start justify-between">
              <div className="space-y-1">
                <h2 className="text-2xl font-semibold">{user.firstName} {user.lastName}</h2>
                <p className="text-muted-foreground">{user.emailAddresses[0].emailAddress}</p>
              </div>
              <Button 
                variant="outline"
                onClick={() => navigate('/settings')}
                className="flex items-center gap-2"
              >
                <Settings className="w-4 h-4" />
                Edit Profile
              </Button>
            </div>
          </Card>

          {/* Subscription Status */}
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">Subscription</h2>
            <SubscriptionManager />
          </div>

          {/* Quick Actions */}
          <div className="grid sm:grid-cols-2 gap-4">
            <Card className="p-6 hover:shadow-md transition-shadow cursor-pointer"
                  onClick={() => navigate('/account/billing')}>
              <div className="flex items-center gap-3">
                <CreditCard className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">Billing & Payments</h3>
                  <p className="text-sm text-muted-foreground">Manage your payment methods</p>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-md transition-shadow cursor-pointer"
                  onClick={() => navigate('/settings/security')}>
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">Security Settings</h3>
                  <p className="text-sm text-muted-foreground">Configure 2FA and security options</p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </PageContainer>
  );
} 